<h2><fa-icon icon="cogs"></fa-icon> Services</h2>
<kendo-grid
  #grid
  [data]="view | async"
  [style.height.%]="100"
  [pageSize]="gridState.take"
  [skip]="gridState.skip"
  [sort]="gridState.sort"
  [pageable]="true"
  [sortable]="true"
  [filterable]="true"
  (dataStateChange)="onStateChange($event)"
  (edit)="editHandler($event)"
  (remove)="removeHandler($event)"
  (add)="addHandler()"
  [navigable]="true"
  [loading]="loading"
  [resizable]="true"
>
  <ng-template kendoGridToolbarTemplate>
    <button class="btn btn-primary" kendoGridAddCommand>
      <fa-icon icon="plus"></fa-icon>
    </button>
  </ng-template>
  
  <kendo-grid-column
    field="Id"
    title="ID"
    width="100"
    [editable]="false"
    [hidden]="true"
  >
  </kendo-grid-column>

  <kendo-grid-column field="Code" title="Code">  
  </kendo-grid-column>

  <kendo-grid-column field="Name" title="Name"> 
  </kendo-grid-column>

  <kendo-grid-column field="IsLocked" title="Locked"> 
  </kendo-grid-column> 

  <kendo-grid-command-column title="" width="120">
    <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem="dataItem">
      <button class="btn btn-primary" kendoGridEditCommand>
        <fa-icon icon="external-link-alt"></fa-icon>
      </button>
      <button class="btn btn-danger" kendoGridRemoveCommand [disabled]="dataItem.IsLocked">
        <fa-icon icon="trash"></fa-icon>
      </button>
    </ng-template>
  </kendo-grid-command-column>

  <div *kendoGridDetailTemplate="let dataItem">
    <app-service-configuration-keys
      [service]="dataItem">
    </app-service-configuration-keys>
  </div>
</kendo-grid>

<app-service-detail [model]="editItem" [isNew]="isNew"
(save)="saveHandler($event)"
(cancel)="cancelHandler()">
</app-service-detail>
